<template>
  <div class="update">
    <Header
      type="1"
      :route="'/xsxxxgsq/index?active=' + info.active"
      :title="info.title"
    ></Header>
    <jbxx ref="jbxx" v-if="info.title === '基本信息'"></jbxx>
    <jhrxx ref="jhrxx" :info="info" v-if="info.title === '监护人信息'"></jhrxx>
    <jtcy ref="jtcy" :info="info" v-if="info.title === '家庭成员'"></jtcy>
    <jtzz ref="jtzz" :info="info" v-if="info.title === '家庭住址'"></jtzz>
    <jl ref="jl" :info="info" v-if="info.title === '简历'"></jl>
    <div class="update-button">
      <van-button type="default" @click="cancel">取消</van-button>
      <van-button type="primary" @click="saveData">保存</van-button>
    </div>
  </div>
</template>
<script>
import jbxx from "./mode/jbxx.vue";
import jhrxx from "./mode/jhrxx.vue";
import jtcy from "./mode/jtcy.vue";
import jtzz from "./mode/jtzz.vue";
import jl from "./mode/jl.vue";
export default {
  components: { jbxx, jhrxx, jtcy, jtzz, jl },
  data() {
    return {
      info: {}
    };
  },
  created() {
    this.info = this.$route.query;
  },
  methods: {
    cancel() {
      this.$router.replace("/xsxxxgsq/index?active=" + this.info.active);
    },
    saveData() {
      switch (this.info.title) {
        case "基本信息":
          this.$refs.jbxx.saveData();
          break;
        case "监护人信息":
          this.$refs.jhrxx.saveData();
          break;
        case "家庭成员":
          this.$refs.jtcy.saveData();
          break;
        case "家庭住址":
          this.$refs.jtzz.saveData();
          break;
        case "简历":
          this.$refs.jl.saveData();
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.update {
  height: 100%;
  background-color: #f2f2f4;
  overflow: auto;
  .mode {
    height: calc(~"100% - 78px");
    margin-top: 8px;
    background-color: #f2f2f4;
    overflow: auto;
    /deep/.van-cell-group {
      margin-bottom: 8px;
      .van-cell {
        padding: 14px 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
        &::after {
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }
        .van-field__label {
          width: fit-content;
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
          }
        }
        .van-field__error-message{
          text-align: right;
        }
        .van-field__control::placeholder {
          color: #b2b2b2 !important;
        }
        .van-field__right-icon {
          .van-icon {
            color: #b2b2b2;
          }
        }
        .van-field__word-limit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #b2b2b2;
          letter-spacing: 0.3px;
          font-weight: 400;
        }
        &.qz-textarea {
          flex-direction: column;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0.3px;
          font-weight: 400;
          .van-field__control::placeholder {
            color: #b2b2b2 !important;
          }
        }
      }
    }
  }
  .update-button {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    background: #ffffff;
    padding: 10px 15px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      height: 100%;
      width: calc(~"50% - 7.5px");
      border: 1px solid #e5e5e5;
      border-radius: 25px !important;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .van-button--normal {
      color: #666666;
    }
    .van-button--primary {
      color: #ffffff;
      background-color: #7469f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/update.vue